import { PARTNER_BASIC_INFO_TRANSLATIONS_NAMESPACE } from '../../../translations'

export const TRANSLATION_KEYS = {
  fieldLabel: 'partnerbasicinfo-partner-head',
  salesCountLabel: 'partnerbasicinfo-head-sales-count',
  servicesCountLabel: `${PARTNER_BASIC_INFO_TRANSLATIONS_NAMESPACE}--partner-head--services-label`,
}
